import type { Env } from "./schema";

/**
 * 環境 → tenant_id → partnerKey。
 * tenant_id は company-auth 采番の自前 ID（generic・JWT top-level クレーム。統括タスク1 決定）。
 * 値は環境ごとに異なるため、環境非依存の partnerKey へ対応づける。
 * 提携先を増やすときはここにエントリを足し、tenants/ に定義を追加するだけ（消費側のコード変更なし）。
 */
export const tenantMap: Record<Env, Record<string, string>> = {
  stg: {
    "blue-rocket-m253k": "blue-rocket",
  },
  prod: {
    "blue-rocket-t25mf": "blue-rocket",
  },
};
